<template>
  <div class="home-transition-hero">
<!--    <img src="@/assets/images/Home_Transition_Hero_Asset.svg" alt="">-->
  </div>
</template>

<script>
export default {
  name: 'HomeTransition2',
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">
.home-transition-hero {
  display: flex;
  justify-content: center;
  overflow: hidden;
  margin: -70px auto;
  //min-width: 1920px;
  height: 605px;
  background-image: url("~@/assets/images/Home_Transition_Hero_Asset.svg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
</style>
